import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { ThemeProvider } from '@mui/material/styles';
import { Box } from '@mui/material';
import { dashboardDarkTheme, colors } from '@src/styles';
import { fadeInUpSX } from '@src/styles/animations';
import { ScopePeriodBar, OrgView, AutomationView, RunDetailsDrawer, SelectOrganizationState } from './components';
import { useRunsContext } from './context/RunsContext';

function ScopeSwitch() {
  const { scope, organizationId } = useRunsContext();
  const hasOrganization = scope !== 'all' && Boolean(organizationId);
  return (
    <Box key={hasOrganization ? `org-${organizationId}` : 'picker'} sx={fadeInUpSX()}>
      {!hasOrganization ? <SelectOrganizationState /> : scope === 'org' ? <OrgView /> : <AutomationView />}
    </Box>
  );
}

export function RunsView() {
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <ThemeProvider theme={dashboardDarkTheme}>
        <Box
          sx={{
            p: { xs: 0.5, md: 1 },
            display: 'flex',
            flexDirection: 'column',
            gap: 2.5,
            backgroundColor: colors.background.primary,
            ...fadeInUpSX(),
          }}
        >
          <ScopePeriodBar />
          <ScopeSwitch />
        </Box>
        <RunDetailsDrawer />
      </ThemeProvider>
    </LocalizationProvider>
  );
}
